export default __webpack_public_path__ + "static/media/icon-arrow-down.3c8b9b9d.webp";